import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SharedCalGuide from "../../SharedCalGuide";
import $ from "jquery";
import CallAPI from "../../../../services/apiCalls";
import useUserStore from "../../../../utils/storeApp";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { stateCodeArray } from "../../../../services/fakeDB/ListUser";
import * as treeFunc from "../../../../services/ReportsTree";

let search = {
  Name: null,
  NameFilter: null,
  Email: null,
  EmailFilter: null,
  StartDate: null,
  EndDate: null,
  OrganizationId: null,
  OrganizationName: null,
  ReportedUserEvent: "UserLocked",
  DateFilter: "ModifiedDate",
  IncludeSubOrgs: false,
  DomainName: null,
  DomainId: null,
  VendorName: null,
  VendorId: null,
  MessageForwardingStatus: null,
  MaxSize: null,
  MinSize: null,
  DeleteReportName: null,
  City: null,
  State: null,
};
const SearchUserStatus = () => {
  const navigate = useNavigate();
  const { userToken, SetSharedObject, sharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [date, setDate] = useState(null);
  const [startdate, setStartDate] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());
  const [processing, SetProcessing] = useState(false);
  const [domainObj, SetDomainObj] = useState([]);
  const [orgBulkObj, SetOrgBulkObj] = useState([]);
  const [answers, setAnswers] = useState(search);
  const [custObj, SetCustObj] = useState([]);
  const [submFlag, setSubmFlag] = useState(false);
  const setAnswer = (questionId, answer) => {
    setAnswers((prev) => ({ ...prev, [questionId]: answer }));
  };
  const [domainName, setDomainName] = useState(null);
  const [domainId, setDomainId] = useState(null);
  const [organizationName, setOrganizationName] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [vendorName, seVendorName] = useState(null);
  const [vendorId, seVendorId] = useState(null);
  const [selectedKeys, setSelectedKeys] = useState(null);
  const [newFileName, setNewFileName] = useState("");
  const [submInputFlag, setSubmitInputFlag] = useState(false);
  const [orgRequired, setOrgRequired] = useState(false);
  const [domainRequired, setDomainRequired] = useState(false);
  const [customerRequired, setCustomerRequired] = useState(false);
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [orgTreeFilter, setOrgTreeFilter] = useState("");
  const [filteredOrgTree, setFilteredOrgTree] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("userStatusSearchModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  useEffect(() => {
    setSubmFlag(false);
    $("#startDate")
      .datepicker()
      .on("changeDate", function (e) {
        setNewDate(e.date);
        setStartDate(new Date(e.date));
        $("#startDate").datepicker("hide");
        let dt = e.date;
        let max = new Date(dt.getFullYear(), dt.getMonth() + 3, dt.getDate());
        $("#endDate").datepicker("setDate", new Date());
        $("#endDate").datepicker("show");
      });
    $("#endDate")
      .datepicker()
      .on("changeDate", function (e) {
        setDate(new Date(e.date));
        setEndDate(new Date(e.date));
        $("#endDate").datepicker("hide");
      });
    $("#startDate").datepicker("setDate", getLastWeek(true));
    $("#endDate").datepicker("setDate", new Date(getLastWeek()));
    setEndDate(new Date());
    setStartDate(new Date(getLastWeek(true)));
    if (
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR"
    ) {
      getDomains();
    } else {
      let dmId = parseInt(userSession.domain_id);
      setDomainId(dmId);
      setAnswers({
        ...answers,
        OrganizationId: userSession.org_id,
        DomainId: userSession.domain_id,
      });
      if (!isEmpty(sharedObject.UserActiviyStatus))
        getOrgByVendors(userSession.vendor_id + "~List~" + dmId, true);
    }
  }, [sharedObject.UserActiviyStatus]);
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const getLastWeek = (flag) => {
    let today = new Date();
    let month = flag ? today.getMonth() - 3 : today.getMonth();
    let lastWeek = new Date(today.getFullYear(), month, today.getDate());
    return lastWeek;
  };
  const setNewDate = (selected) => {
    let dt = new Date(selected);
    let today = new Date();
    setMinDate(dt);
    let max = new Date(dt.getFullYear(), dt.getMonth() + 3, dt.getDate());
    setMaxDate(max);
    if (max > today) {
      setMaxDate(today);
    }
    //$("#endDate").datepicker("setEndDate", max);
    $("#endDate").datepicker("setDate", null);
    setEndDate(null);
  };
  const getDomains = async () => {
    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR"
    ) {
      await { ...answers, VendorId: userSession.vendor_id };
    }
    SetProcessing(true);
    SetOrgBulkObj([]);
    let call = "/customers/GetUserDomains";
    const res = await CallAPI(call, false, "get", userToken);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      const obj = res.data.data.map((el) => ({
        ...el,
        show: true,
      }));
      SetDomainObj(obj);
      if (
        userRole !== "SES ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR" &&
        obj.length === 1
      ) {
        await { ...answers, DomainId: userSession.domain_id };
        getOrgByVendors(`${userSession.vendor_id}~List`);
      }
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const getSubOrgList = async (parentId, parentName) => {
    SetProcessing(true);
    let model = { ParentOrganizationId: parentId };
    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, model, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let arr = res.data.data;
      let newArr = [];
      let parentVal = { name: parentName, value: parentId, show: true };
      newArr.push(parentVal);
      for (var i = 0; i < arr.length; i++) {
        var val = { text: arr[i].name, value: arr[i].id, show: true };
        newArr.push(val);
      }
      return newArr;
    } else {
      return "error";
    }
  };
  const getMessages = async () => {
    setSubmFlag(true);
    setNoResults(false);
    let call =
      "/reports/UserStatus?searchPhrase=''&sortDir=userNameDisplay&sortBy=userNameDisplay";
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    if (sharedObject.UserActiviyStatus === "bulk") {
      if (checked.length === 0) {
        setOrgRequired(true);
        return;
      }
      const temp = [];
      checked.forEach((elem) => {
        let e = elem.split("~");
        let o = {
          Key: parseInt(e[0]),
          Value: e[1],
        };
        temp.push(o);
      });
      SetOrgBulkObj(temp);
    }
    const isDomainShown =
        userRole === "SES ADMINISTRATOR" ||
        (userRole === "SYSTEMADMINISTRATOR" && domainObj.length > 0);
    if (isDomainShown && !domainId) {
          setDomainRequired(true);
          return;
    }
    const isAdmin =
        userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR";
    if (isAdmin && !vendorName) {
        setCustomerRequired(true);
        return;
    }
    if (!organizationId && sharedObject.UserActiviyStatus === "reg") {
      setOrgRequired(true);
      return;
    } else if (!startdate) {
      document.getElementById("startDate").scrollIntoView();
      document.getElementById("startDate").focus();
      return;
    } else if (!enddate) {
      document.getElementById("endDate").scrollIntoView();
      document.getElementById("endDate").focus();
      return;
    }
    let reportName =
      answers.ReportedUserEvent === "OrganizationEmailDeleted"
        ? "Deleted Organization Email Report"
        : answers.ReportedUserEvent === "UserAccountEmailDeleted"
          ? "Deleted User Email Report"
          : "Deleted User Report";
    let finalSearch = {
      ...answers,
      DomainName: domainName,
      DomainId: domainId,
      OrganizationName: organizationName,
      VendorName: vendorName,
      VendorId: vendorId,
      OrganizationId: organizationId,
      StartDate: new Date(StartDate),
      EndDate: new Date(EndDate),
      DeleteReportName: reportName,
    };
    let refObj = { ...finalSearch };

    if (sharedObject.UserActiviyStatus === "bulk") {
      CloseSearchModal();
      $("#InputDownloadModalSearchRec").modal("show");
      setSubmitInputFlag(false);
      return;
    } else {
      if (answers.IncludeSubOrgs) {
        const subOrgList = await getSubOrgList(
          organizationId,
          organizationName,
        );
        if (subOrgList === "error") {
          console.log("Unable to get sub org list.");
          SetProcessing(false);
          return;
        }
        const newArray = subOrgList.filter((obj) => obj.Value !== "Root");
        refObj = await { ...finalSearch, OrgList: JSON.stringify(newArray) };
      }
    }
    SetProcessing(true);
    SetSharedObject("statusSearch", refObj);
    const res = await CallAPI(call, refObj, "post", userToken);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      const results = res.data.data;
      const isEmpty =
        !results ||
        results.count === 0 ||
        !Array.isArray(results.pageItems) ||
        results.pageItems.length === 0;
      setNoResults(isEmpty);
      SetSharedObject("UserActiviySearch", results);
      $("#userStatusSearchModal").modal("show");
      setAnswers((prev) => ({
        ...prev,
        BaseDomainId: "",
        VendorVal: "",
        Org: "",
      }));
      setDomainId(null);
      setDomainName(null);
      seVendorName(null);
      setOrganizationId(null);
      setOrganizationName(null);
      SetCustObj([]);
      if (
        userRole === "SES ADMINISTRATOR" ||
        userRole === "SYSTEMADMINISTRATOR"
      ) {
        SetOrgObject([]);
      }
    } else {
      SetProcessing(false);
    }
  };

  const getVendorsByDomain = async (id) => {
    let dom = id.split("~");
    setDomainRequired(false);
    setDomainId(dom[0]);
    setDomainName(dom[1]);
    SetProcessing(true);
    let call = "/admin/getVendorsByDomain?domainId=" + dom[0];
    const res = await CallAPI(call, null, "post", userToken);
    if (res.status === "SUCCESS") {
      let temp = [];
      if (res.data.data) {
        for (let el of res.data.data) {
          el.show = true;
          temp.push(el);
        }
      }
      SetCustObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    setAnswer("BaseDomainId", id);
    await setAnswer("DomainId", dom[0]);
  };

  const filterList = (val, list, setList, labelKey = "text") => {
    const updated = list.map((el) => {
      const label = el[labelKey]?.toLowerCase?.() || "";
      return {
        ...el,
        show: val.length > 1 ? label.includes(val.toLowerCase()) : true,
      };
    });
    setList(updated);
  };
  const filterDomains = (val) => filterList(val, domainObj, SetDomainObj);
  const filterOrganizations = (val) => filterList(val, orgObject, SetOrgObject);
  const filterVendors = (val) => filterList(val, custObj, SetCustObj);

  const [orgObject, SetOrgObject] = useState([]);
  const getOrgByVendors = async (val) => {
    let domId = val.split("~");
    setCustomerRequired(false);
    seVendorName(domId[1]);
    const domainNr = domId[2] ? domId[2] : domainId;
    await setAnswer("VendorId", parseInt(domId[0]));
    SetProcessing(true);
    let call = null;
    if (sharedObject.UserActiviyStatus === "reg") {
      let obj = sharedObject.getOrgsObj;
      let temp = [];
      if (obj) {
        for (let el of obj) {
          if (parseInt(domId[0]) === el.vendorId) {
            var o = { value: "", show: true, text: "" };
            o.value = el.id;
            o.text = el.name;
            temp.push(o);
          }
        }
      }
      SetOrgObject(temp);
    } else if (sharedObject.UserActiviyStatus === "bulk") {
      let org = answers.OrganizationId
        ? parseInt(answers.OrganizationId)
        : userRole !== "SES ADMINISTRATOR" && userRole !== "SYSTEMADMINISTRATOR"
          ? parseInt(userSession.org_id)
          : "";
      let vendor = domId[0] ? parseInt(domId[0]) : "";
      let domain = answers.DomainId
        ? parseInt(answers.DomainId)
        : userRole !== "SES ADMINISTRATOR" && userRole !== "SYSTEMADMINISTRATOR"
          ? parseInt(userSession.domain_id)
          : "";
      call = "/organization/GetOrganizationTree?vendorId=" + vendor;
      var ob = { ...answers, VendorId: domId[0] };
      SetProcessing(true);
      const res = await CallAPI(call, ob, "post", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let obj = res.data.data.value?.orgNode;
        if (obj) {
          let o = treeFunc.treeObj(obj);
          SetOrgObject(o);
        }
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    }
    SetProcessing(false);
  };

  const QueueDownloadSearch = async () => {
    setSubmitInputFlag(true);
    if (newFileName === "" || hasInvalidChars) {
      return;
    }
    let StartDate = $("#startDate").datepicker("getFormattedDate");
    let EndDate = $("#endDate").datepicker("getFormattedDate");
    let obj = {
      ...answers,
      DomainName: domainName,
      DomainId: null,
      OrganizationName: organizationName,
      VendorName: vendorName,
      OrganizationId: null,
      StartDate: new Date(StartDate),
      EndDate: new Date(EndDate),
    };
    const newArray = orgBulkObj.filter((obj) => obj.Value !== "Root");
    let refObj = { ...obj, OrgList: JSON.stringify(newArray) };
    SetProcessing(true);
    let call =
      "/reports/ExportReceiveUserStatus?sortBy=SentDate&sortDir=SentDate&fileName=" +
      newFileName +
      "&reportType=6";
    const res = await CallAPI(call, refObj, "post", userToken);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      SetCustObj([]);
      SetOrgObject([]);
      setAnswer("BaseDomainId", "");
      setSubmitInputFlag(false);
      setOrgRequired(false);
      CloseCreateFilenameModal();
      $("#downloadProgressModal").modal("show");
    } else if (res.status === "SERVERERROR") {
      let msg = res.message;
      let str = "<div>";
      str += msg + "</div>";
      SetProcessing(false);
    }
  };
  const getTreeOrg = (e) => {
    const obj = e.value;
    if (obj && Object.keys(obj).length > 0) {
      setOrgRequired(false);
    }
    setSelectedKeys(e.value);
  };
  useEffect(() => {
    if (orgTreeFilter.length > 1) {
      const filtered = filterTree(orgObject, orgTreeFilter);
      setFilteredOrgTree(filtered);
    } else {
      setFilteredOrgTree(orgObject);
    }
  }, [orgTreeFilter, orgObject]);

  const filterTree = (nodes, filterText) => {
    return nodes
      .map((node) => {
        if (
          node.label.toLowerCase().includes(filterText.toLowerCase()) ||
          (node.children && filterTree(node.children, filterText).length > 0)
        ) {
          return {
            ...node,
            children: node.children
              ? filterTree(node.children, filterText)
              : [],
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  const collectAllValues = (nodes) => {
    const out = [];
    const walk = (arr) => {
      arr?.forEach((n) => {
        out.push(n.value);
        if (n.children?.length) walk(n.children);
      });
    };
    walk(orgObject);
    return out;
  };

  const getRootValue = () => orgObject?.[0]?.value;

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const invalidCharsRegex =
    /[\/\\|{}\[\]\(\)\*\%\$\#\@\!\^\&\?\<\>\:\;\"\'\=\+\,]/g;
  const hasInvalidChars = invalidCharsRegex.test(newFileName);
  useEffect(() => {
    const modalEl = $("#InputDownloadModalSearchRec");
    const handleModalClose = () => {
      setNewFileName("");
      setSubmitInputFlag(false);
    };

    modalEl.on("hidden.bs.modal", handleModalClose);

    return () => {
      modalEl.off("hidden.bs.modal", handleModalClose);
    };
  }, []);
  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $(`#${modalId}`).modal("hide");
  };

  const CloseSearchModal = () => closeModal("userStatusSearchModal");
  const CloseCreateFilenameModal = () =>
    closeModal("InputDownloadModalSearchRec");

  return (
    <div className="SearchListMailboxSize">
      <div
        className="modal fade"
        id="userStatusSearchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="search-userstatus-title"
        aria-describedby="searchUserStatusDesc"
        data-backdrop="static"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
                {sharedObject.UserActiviyStatus === "reg" ? (
                  <h2
                    className="modal-title spacer-inline text-size3"
                    id="search-userstatus-title"
                  >
                    Search
                  </h2>
                ) : (
                  <h2
                    className="modal-title spacer-inline"
                    id="search-userstatus-title"
                  >
                    Download
                    <div className="text-size6 line-s1">Big Data</div>
                  </h2>
                )}
              <button
                type="button"
                className="close"
                aria-label="Close user status search"
                onClick={(e) => {
                  CloseSearchModal();
                  if (
                    userRole === "SES ADMINISTRATOR" ||
                    userRole === "SYSTEMADMINISTRATOR"
                  )
                    SetOrgObject([]);
                  SetCustObj([]);
                  setSubmitInputFlag(false);
                  setAnswer("BaseDomainId", "");
                  setOrgRequired(false);
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form aria-label="Search user activity">
                <div className="modal-body">
                    <p id="searchUserStatusDesc" className="sr-only">
                          Use this form to search or download user status report.
                          Fields marked with an asterisk are required.
                    </p>
                  <div className="modal-content-body container">
                    {userRole === "SES ADMINISTRATOR" ||
                    (userRole === "SYSTEMADMINISTRATOR" && domainObj.length > 0) ? (
                      <div className="field-wrapper">
                        <label htmlFor="domainSelect">
                            Domain
                            <span aria-hidden="true" className="rd-clr"> *</span>
                        </label>
                        <span className="filter-container dg-clr spacer-margin8">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            aria-label="Filter domains"
                            onChange={(el) => filterDomains(el.target.value)}
                          />
                        </span>
                        <select
                          className="form-control"
                          id="domainSelect"
                          name="DomainId"
                          size="4"
                          value={answers.BaseDomainId}
                          onChange={(el) => {
                            if (el.target.value !== "") {
                              SetOrgObject([]);
                              getVendorsByDomain(el.target.value);
                            }
                          }}
                        >
                          <option value="">Select Domain</option>
                          {domainObj?.map((el) => {
                            if (el.show)
                              return (
                                <option
                                  key={el.value}
                                  value={el.value + "~" + el.text}
                                >
                                  {el.text}
                                </option>
                              );
                          })}
                        </select>
                        {
                          submFlag && domainRequired ? (
                            <div
                              className="alert alert-danger"
                              role="alert"
                              aria-live="assertive"
                              aria-atomic="true"
                            >
                              Domain is required.
                            </div>
                          ):null
                        }
                      </div>
                    ) : null}
                    {userRole === "SES ADMINISTRATOR" ||
                    userRole === "SYSTEMADMINISTRATOR" ? (
                      <div className="field-wrapper">
                        <label htmlFor="customerSelect">
                            Customer
                            <span aria-hidden="true" className="rd-clr"> *</span>
                        </label>
                        <span className="filter-container dg-clr spacer-margin8">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            aria-label="Filter customers"
                            onChange={(el) => filterVendors(el.target.value)}
                          />
                        </span>
                        <select
                          size="4"
                          className="form-control"
                          name="VendorName"
                          id="customerSelect"
                          value={answers?.VendorVal || ""}
                          onChange={(el) => {
                            if (el.target.value !== "") {
                              setAnswer("VendorVal", el.target.value);
                              getOrgByVendors(el.target.value);
                            }
                          }}
                        >
                          <option value="">Select Customer</option>
                          {custObj?.map((el) => {
                            if (el.show)
                              return (
                                <option
                                  key={el.value}
                                  value={el.value + "~" + el.text}
                                >
                                  {el.text}
                                </option>
                              );
                          })}
                        </select>
                        {
                          submFlag && customerRequired ? (
                            <div
                              className="alert alert-danger"
                              role="alert"
                              aria-live="assertive"
                              aria-atomic="true"
                            >
                              Customer is required.
                            </div>
                          ):null
                        }
                      </div>
                    ) : null}

                    {/*Organization*/}
                    <div>
                      <label htmlFor="organizationSelect">
                        Organization
                        <span aria-hidden="true" className="rd-clr"> *</span>
                      </label>
                      {sharedObject.UserActiviyStatus === "reg" ? (
                        <div className="filter-container dg-clr spacer-margin8">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            aria-label="Filter organizations"
                            onChange={(el) => filterOrganizations(el.target.value)}
                          />
                        </div>
                      ) : null}
                      {orgObject.length === 0 ? (
                        <div className="watermark-wrapper sp-margin16" role="status" aria-live="polite" aria-atomic="true">
                          No Results
                        </div>
                      ) : sharedObject.UserActiviyStatus === "reg" ? (
                        <select
                          className="form-control"
                          size="4"
                          name="OrganizationId"
                          id="organizationSelect"
                          value={answers?.Org}
                          onChange={(el) => {
                            let val = el.target.value;
                            if (val !== "") {
                              setOrgRequired(false);
                              let domId = val.split("~");
                              setOrganizationName(domId[1]);
                              setOrganizationId(domId[0]);
                              setAnswer("Org", val);
                            }
                          }}
                        >
                          <option value="">Select Organization</option>
                          {orgObject?.map((el) => {
                            if (el.show)
                              return (
                                <option
                                  key={el.value}
                                  value={el.value + "~" + el.text}
                                >
                                  {el.text}
                                </option>
                              );
                          })}
                        </select>
                      ) : (
                        <div>
                          <span className="treefilter-wrapper filter-container dg-clr spacer-margin8">
                            <input
                              type="text"
                              className="form-control filter-sm pr-4 pos-1"
                              placeholder="Filter"
                              aria-label="Filter organization tree"
                              value={orgTreeFilter}
                              onChange={(e) => setOrgTreeFilter(e.target.value)}
                            />
                            {orgTreeFilter && (
                              <button
                                type="button"
                                onClick={() => setOrgTreeFilter("")}
                                className="clear-button"
                                aria-label="Clear organization filter"
                              >
                                <i className="bi bi-x" aria-hidden="true"></i>
                              </button>
                            )}
                          </span>
                          <CheckboxTree
                            nodes={filteredOrgTree}
                            checked={checked}
                            expanded={expanded}
                            onCheck={(nextChecked) => {
                              const rootVal = getRootValue();
                              const wasRootChecked = checked?.includes(rootVal);
                              const isRootChecked = nextChecked?.includes(rootVal);

                              if (!wasRootChecked && isRootChecked) {
                                setChecked(collectAllValues(orgObject));
                              } else if (wasRootChecked && !isRootChecked) {
                                setChecked([]);
                              } else {
                                setChecked(nextChecked);
                              }
                            }}
                            onExpand={setExpanded}
                            noCascade={true}
                            showExpandAll={true}
                          />
                        </div>
                      )}
                      {submFlag && orgRequired ? (
                        <div 
                            id="organizationAlert" 
                            className="alert alert-danger" 
                            role="alert" 
                            aria-live="assertive" 
                            aria-atomic="true"
                          >
                            Organization is required.
                         </div>
                      ) : null}
                    </div>
                    {sharedObject.UserActiviyStatus === "reg" ? (
                      <div className="spacer-margin3">
                      <label htmlFor="includeSubOrgs" className="label-sub d-flex align-items-center gap-2 sp-margin3">
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                           id="includeSubOrgs"
                          value={answers.IncludeSubOrgs}
                          onChange={(el) => {
                            setAnswer("IncludeSubOrgs", el.target.checked);
                          }}
                        />
                          Include Sub Organizations
                        </label>
                      </div>
                    ) : null}

                    {/* Calendar */}
                    <div className="field-wrapper sp-margin4">
                      <div className="spacer-margin5 spacer-inline w-md2 v-top">
                        <label htmlFor="startDateInput">
                            Start Date
                            <span aria-hidden="true" className="rd-clr"> *</span>
                        </label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          id="startDate"
                          data-date-end-date="1d"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="StartDate"
                            id="startDateInput"
                            autoComplete="off"
                            aria-required="true"
                          />
                          <div className="input-group-append">
                            <button
                                type="button"
                                className="input-group-text" 
                                id="startDateButton"
                                aria-label="Open start date calendar"
                                >
                                <i className="fas fa-calendar" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                        {submFlag && !startdate ? (
                          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">Start date is required.</div>
                        ) : null}
                      </div>

                      {/*End Date*/}
                      <div className="spacer-inline w-md2 v-top">
                        <label htmlFor="endDateInput">
                            End Date
                            <span aria-hidden="true" className="rd-clr"> *</span>
                        </label>
                        <div
                          className="input-group date end-date"
                          data-provide="datepicker"
                          id="endDate"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="EndDate"
                            id="endDateInput"
                            autoComplete="off"
                            aria-required="true"
                          />
                          <div className="input-group-append">
                            <button 
                            type="button"
                            className="input-group-text" 
                            id="endDateButton" 
                            aria-label="Open end date calendar" 
                            >
                                <i className="fas fa-calendar" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                        {submFlag && !enddate ? (
                          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">End date is required.</div>
                        ) : null}
                      </div>
                    </div>
                    <SharedCalGuide />
                    {/* Search by Name */}
                    <div className="field-wrapper">
                      <div className="field-wrapper">
                        <div className="spacer-inline w-md2 spacer-margin5">
                          <label htmlFor="city">City</label>
                          <input
                            className="form-control"
                            name="City"
                            id="city"
                            autoComplete="address-level2"
                            value={answers.City}
                            onChange={(el) => {
                              setAnswer("City", el.target.value);
                            }}
                          />
                        </div>

                        {/* Searcy by State */}
                        <div className="spacer-inline w-md2">
                          <label htmlFor="state">State</label>
                          <select
                            className="form-control"
                            name="State"
                            id="state"
                            value={answers.State}
                            onChange={(el) => {
                              setAnswer("State", el.target.value);
                            }}
                          >
                            <option value="">Select</option>
                            {stateCodeArray.map((el) => (
                              <option key={el} value={el}>
                                {el}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Search by Name */}
                      <div className="field-wrapper">
                        <div className="spacer-margin5 spacer-inline w-md2">
                          <label htmlFor="SearchName">Name</label>
                          <select
                            className="form-control w-md2"
                            name="NameFilter"
                            id="SearchName"
                            value={answers.NameFilter}
                            onChange={(el) => {
                              setAnswer("NameFilter", el.target.value);
                            }}
                          >
                            <option value="">Search By</option>
                            <option value="UserName">Username</option>
                            <option value="FirstName">First Name</option>
                            <option value="LastName">Last Name</option>
                          </select>
                        </div>
                        <input
                          className="form-control spacer-inline w-md2"
                          name="Name"
                          id="Name"
                          autoComplete="off"
                          aria-label="Name value"
                          placeholder="Enter Name"
                          value={answers.Name}
                          onChange={(el) => {
                            setAnswer("Name", el.target.value);
                          }}
                        />
                      </div>
                      {/* Search by Direct Email */}
                      <div className="field-wrapper">
                        <div className="spacer-margin5 spacer-inline w-md2">
                          <label htmlFor="emailFilter">Email</label>
                          <select
                            className="form-control w-md2"
                            name="EmailFilter"
                             id="emailFilter"
                            value={answers.EmailFilter}
                            onChange={(el) => {
                              setAnswer("EmailFilter", el.target.value);
                            }}
                          >
                            <option value="">Search By</option>
                            <option value="DirectEmail">Direct Email</option>
                            <option value="ContactEmail">Contact Email</option>
                          </select>
                        </div>
                        <input
                          className="form-control spacer-inline w-md2"
                          placeholder="Enter Email"
                          name="Email"
                          id="emailValue"
                          autoComplete="off"
                          aria-label="Email value"
                          value={answers.Email}
                          onChange={(el) => {
                            setAnswer("Email", el.target.value);
                          }}
                        />
                      </div>
                    </div>
                    {noResults ? (
                      <div
                        className="alert alert-secondary"
                        role="alert"
                        aria-live="polite"
                        aria-atomic="true"
                      >
                        We did not find any results based on your criteria.
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => getMessages()}
                    ref={firstFocusRef}
                  >
                    {sharedObject.UserActiviyStatus === "reg"
                      ? "Search"
                      : "Continue"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={(e) => {
                      CloseSearchModal();
                      if (
                        userRole === "SES ADMINISTRATOR" ||
                        userRole === "SYSTEMADMINISTRATOR"
                      )
                        SetOrgObject([]);
                      SetCustObj([]);
                      setSubmitInputFlag(false);
                      setAnswer("BaseDomainId", "");
                      setOrgRequired(false);
                    }}
                  >
                    Cancel
                  </button>
                  {processing && (
                    <div 
                        className="loader-container" 
                        role="status" 
                        aria-live="polite" 
                        aria-atomic="true"
                        aria-labelledby="search-userstatus-loader"
                    >
                        <div className="spinner" aria-hidden="true"></div>
                        <div className="loading-text" id="search-userstatus-loader">{loadingText}</div>
                    </div>
                  )}
                </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="InputDownloadModalSearchRec"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="create-filename-title"
        aria-describedby="CreateFilenameDesc"
        data-backdrop="static"
        aria-modal="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title " id="create-filename-title">
                Download Filename
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close Create Filename Modal"
                onClick={CloseCreateFilenameModal}
                disabled={processing}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-body">
                <p className="descript-container" id="CreateFilenameDesc">
                  Enter a new name to identify your download file once it has
                  been queued in the download status page.
                </p>
                <div className="modal-content-form">
                  <label htmlFor="newFileName">Create a new filename</label>
                  <input
                    className="form-control"
                    name="NewFileName"
                    id="newFileName"
                    autoComplete="off"
                    value={newFileName}
                    onChange={(el) => setNewFileName(el.target.value)}
                  />
                  {submInputFlag && newFileName === "" && (
                    <div className="alert alert-danger">
                      Filename is required
                    </div>
                  )}

                  {submInputFlag && hasInvalidChars && (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                      Please remove any special characters.
                    </div>
                  )}

                  <div className="field-wrapper sp-margin3 descript-container" role="alert" aria-live="assertive" aria-atomic="true">
                    Downloading may take several minutes to hours depending on
                    the number of records and timeframe of the report.
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={QueueDownloadSearch}
                disabled={processing}
                aria-label="Queue Download"
              >
                {processing ? "Processing..." : "Queue Download"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseCreateFilenameModal}
                disabled={processing}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchUserStatus;
